import { createFileRoute } from '@tanstack/react-router';

import { BirdGameView, birdGameStore } from '@/features/bird-game';

export const Route = createFileRoute('/_authenticated/bird-game/')({
  onEnter() {
    birdGameStore.enter();
  },
  onLeave() {
    birdGameStore.exit();
  },
  component: BirdGameView,
});
